module.exports = __webpack_public_path__ + "img/SINGLE DEVICE SX RED.f65399b.svg";